import { map } from 'rxjs/operators';
import { isDisenrolled$ } from '../services/subjects';
import { combineLatest } from 'rxjs';

export function enrolledOnly(observable$) {
    return combineLatest(isDisenrolled$, observable$).pipe(
        map(([isDisenrolled, results]) => (isDisenrolled ? [] : results))
    );
}
